import { InventoryListItem } from "../types/inventory";
import { Product } from "../types/product";
import { get, post } from "./fetch.core";

async function listRecycleProducts() {
  return (await get<Product[]>("/admin/recycle/listProducts")).data;
}

async function receiveRecycle(data: { userId: string; productId: string; warehouseId: string; quantity: number }) {
  const res = await post("/pos/user/receiveRecycle", data);
  return res.data;
}

async function listRecycleLogs(data: { userId: string; paging: { page: number; size: number } }) {
  return (await post<{ list: InventoryListItem[] }>("/pos/inventory/listLog", { ...data, logTypes: ["recycle"] })).data;
}

const recycleCore = {
  listRecycleProducts,
  receiveRecycle,
  listRecycleLogs,
};

export default recycleCore;
